/* eslint-disable @typescript-eslint/no-unused-vars */
import { memberSettingsPathPrefix } from "@src/modules/member/path";

function createPath(path: string, stripPrefix: string = ""): string {
  let concatenatedPath = `${memberSettingsPathPrefix}${path}`;

  if (stripPrefix && concatenatedPath.startsWith(stripPrefix)) {
    concatenatedPath = concatenatedPath.substring(stripPrefix.length);
  }

  return concatenatedPath;
}

type PathFunction = (
  asPathName?: boolean,
  stripPrefix?: string,
  ...args: string[]
) => string;

export const INVOICE_SETTINGS_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/invoices`, stripPrefix);
export const NEW_ORGANIZATION_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/new-organization`, stripPrefix);
export const ORGANIZATION_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/organization`, stripPrefix);
export const PROFILE_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/profile`, stripPrefix);
export const STRIPE_ACCOUNT_RETURN_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  organizationCode: string = "",
) =>
  createPath(
    `/organization/${asPathName ? ":organizationCode" : organizationCode}/stripe-create-account-return-link`,
    stripPrefix,
  );
export const CUSTOM_FIELDS_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/custom-fields`, stripPrefix);
export const CUSTOM_FIELD_NEW_FORM: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/custom-fields/new`, stripPrefix);
export const CUSTOM_FIELD_UPDATE_FORM: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code: string = "",
) =>
  createPath(`/custom-fields/${asPathName ? ":code" : code}/edit`, stripPrefix);

export const INTEGRATIONS: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/integrations`, stripPrefix);

export const SLACK_INTEGRATION_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/integrations/slack`, stripPrefix);

export const SERVICES_LIST_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/services`, stripPrefix);

export const SERVICE_DETAIL_PATH: PathFunction = (
  asPathName: boolean = false,
  stripPrefix: string = "",
  code: string = "",
) => createPath(`/services/${asPathName ? ":code" : code}`, stripPrefix);

export const TIME_ENTRIES_SETTINGS_PATH: PathFunction = (
  _: boolean = false,
  stripPrefix: string = "",
) => createPath(`/time-entries`, stripPrefix);
